/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelTournamentBody
 */
export interface CancelTournamentBody {
    /**
     * Reason for cancellation
     * @type {string}
     * @memberof CancelTournamentBody
     */
    reason?: string;
    /**
     * Whether to refund entry fees to wallet (default true)
     * @type {boolean}
     * @memberof CancelTournamentBody
     */
    refundEntryFees?: boolean;
}

/**
 * Check if a given object implements the CancelTournamentBody interface.
 */
export function instanceOfCancelTournamentBody(value: object): value is CancelTournamentBody {
    return true;
}

export function CancelTournamentBodyFromJSON(json: any): CancelTournamentBody {
    return CancelTournamentBodyFromJSONTyped(json, false);
}

export function CancelTournamentBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelTournamentBody {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'] == null ? undefined : json['reason'],
        'refundEntryFees': json['refundEntryFees'] == null ? undefined : json['refundEntryFees'],
    };
}

export function CancelTournamentBodyToJSON(json: any): CancelTournamentBody {
    return CancelTournamentBodyToJSONTyped(json, false);
}

export function CancelTournamentBodyToJSONTyped(value?: CancelTournamentBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
        'refundEntryFees': value['refundEntryFees'],
    };
}

